import React, {useEffect, useState} from 'react';
import { Tabs, Empty, message } from 'antd';
import { useDirtyContext } from '../../../context/DirtyContext';
import { useProjectContext } from '../../../context/ProjectContext';
import axios from 'axios';

import ProjectConfiguration from "../projectConfiguration/ProjectConfiguration";
import JobCodeConfiguration from '../jobCodeConfiguration/JobCodeConfiguration';
import OGLConfiguration from "../oglConfiguration/OGLConfiguration";
import OrderCardConfiguration from "../orderCardConfiguration/OrderCardConfiguration";
import ConstructionSectionParser from "../constructionSectionParser /jobCodeAssignment/ConstructionSectionParser";
import {getConfig} from "../../../config";
import {DeviData} from "../../../types/DeviData";
import {JobCode} from "../../../types/JobCodes";
import {ViewType} from "../../../types/ViewType";
import ContractDateConfiguration from "../contractDateConfiguration/ContractDateConfiguration";
import OrderOverviewConfiguration from "../orderOverviewConfiguration/OrderOverviewConfiguration";
import { useLocation } from "react-router-dom";

const { TabPane } = Tabs;
const { API_BASE_URL } = getConfig();

const ConfigurationTabs: React.FC = () => {
    const { confirmNavigation } = useDirtyContext();
    const { selectedProject, setSelectedProject } = useProjectContext();
    const [activeTab, setActiveTab] = useState<string>("3");
    const [deviData, setDeviData] = useState<DeviData[]>([]);
    const [filteredData, setFilteredData] = useState<DeviData[]>([]);
    const [jobCodes, setJobCodes] = useState<JobCode[]>([]);
    const [isDeviDataLoaded, setIsDeviDataLoaded] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const p = new URLSearchParams(location.search);
        const tab = p.get("tab");
        if (tab && tab !== activeTab) {
            setActiveTab(tab);
            if (tab === "1" && !isDeviDataLoaded) {
                loadDeviData();
            }
        }
        const proj = p.get("project");
        if (proj && proj !== selectedProject) {
            setSelectedProject(proj);
        }
    }, [location.search]);

    const handleTabChange = (key: string) => {
        confirmNavigation(() => {
            setActiveTab(key);
            if (key === "1" && !isDeviDataLoaded) {
                loadDeviData();
            }
        });
    };

    const loadDeviData = async () => {
        if (!selectedProject || selectedProject === "Alle") {
            return;
        }
        try {
            const [deviResponse, jobCodeResponse] = await Promise.all([
                axios.get<DeviData[]>(`${API_BASE_URL}/getNetworkPlanDeviPositions?auth=VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU&projectNo=${selectedProject}&supplementNo=0`),
                axios.get<JobCode[]>(`${API_BASE_URL}/getNetworkPlanJobCodes?auth=VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU&projectNo=${selectedProject}`)
            ]);
            setDeviData(deviResponse.data);
            setFilteredData(deviResponse.data);
            setJobCodes(jobCodeResponse.data);
            setIsDeviDataLoaded(true);
        } catch (error) {
            message.error("Fehler beim Laden der Devi-Daten.");
        }
    };

    const renderContent = (Component: React.FC<any>, props?: any) => {
        return selectedProject !== "Alle" ? (
            <Component {...props} />
        ) : (
            <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                <Empty description="Bitte ein Projekt auswählen, um diese Konfiguration zu bearbeiten." />
            </div>
        );
    };

    return (
        <div style={{ padding: '20px' }}>
            <Tabs activeKey={activeTab} onChange={handleTabChange}>
                <TabPane tab="Projekt" key="0">
                    {renderContent(ProjectConfiguration)}
                </TabPane>
                <TabPane tab="Devis" key="1">
                    {renderContent(ConstructionSectionParser, {
                        deviData,
                        setDeviData,
                        filteredData,
                        setFilteredData,
                        jobCodes,
                        setJobCodes,
                        selectedProject,
                        viewType: ViewType.NEW_EXTERNAL
                    })}
                </TabPane>
                <TabPane tab="Bauabschnitte" key="2">
                    {renderContent(OGLConfiguration)}
                </TabPane>
                <TabPane tab="Produkte" key="3">
                    {renderContent(JobCodeConfiguration)}
                </TabPane>
                <TabPane tab="Auftragskarten" key="4">
                    {renderContent(OrderCardConfiguration)}
                </TabPane>
                <TabPane tab="Produktions-Bestellungen" key="5">
                    {renderContent(OrderOverviewConfiguration)}
                </TabPane>
                <TabPane tab="Werkvertragstermine" key="6">
                    {renderContent(ContractDateConfiguration)}
                </TabPane>
            </Tabs>
        </div>
    );
};

export default ConfigurationTabs;